import type { ReactElement } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/modules/leads-search-filters/constants";
import type FindExcludeBySuppressionListFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/ExcludeBySuppressionListFilter/ExcludeBySuppressionListFilter";
import type { SuppressionList } from "app/pages/sales-intelligence/sub-modules/management/components/types";

const ExcludeBySuppressionListFilterResult = ({
    filter: { options },
    value = [],
    isExpanded,
    isActionEnabled = true,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindExcludeBySuppressionListFilter>): ReactElement | null => {
    const handleSelect = (id: string) => {
        const numericId = Number(id);
        if (!isNaN(numericId)) {
            const updatedValues = value?.filter((v) => v !== numericId);
            onFilterUpdate(updatedValues);
            onFilterValueRemove?.(updatedValues);
        }
    };

    const chipItems: ChipItem[] = options
        .filter((c) => value.includes(c.id))
        .map((list: SuppressionList) => {
            return {
                id: String(list.id),
                text: list.name,
            };
        });

    if (!chipItems.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleSelect}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default ExcludeBySuppressionListFilterResult;
